import styled from 'styled-components';

export const TagAutocompleteBlock = styled.div`
  display: flex;
  position: relative;
  align-items: left;
  flex-flow: column wrap;
  padding-top: 6px;
  margin-top: 0;
`;
